/**
 * Cart Upsell Add Button — Document-level click handler.
 *
 * Lives as a separate JS file (not inline in cart-upsell-block.liquid)
 * because Shopify's cart-drawer.renderContents() replaces innerHTML and
 * inline <script> tags re-injected via innerHTML are NEVER executed.
 *
 * By being loaded once via <script defer> in the layout HEAD, the listener
 * is bound to `document` and survives all cart-drawer re-renders.
 */
(function () {
  if (window.__cartUpsellInited) return;
  window.__cartUpsellInited = true;

  function publishCartUpdate() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' }); } catch (e) {}
    }
  }

  function renderCartSections(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      try { drawer.renderContents({ sections: sections }); return; } catch (e) {}
    }
    try {
      if (sections && sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var existing = document.querySelector('#CartDrawer');
        if (fresh && existing) existing.innerHTML = fresh.innerHTML;
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest && evt.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.getAttribute('data-original-text') || btn.textContent.trim();
    btn.disabled = true;
    var textEl = btn.querySelector('.cart-upsell__add-text');
    if (textEl) textEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed ' + r.status);
        return r.json();
      })
      .then(function () {
        return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', {
          credentials: 'same-origin',
          cache: 'no-store',
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        renderCartSections(sections);
        publishCartUpdate();
      })
      .catch(function (err) {
        console.warn('[cart-upsell] add failed', err);
        btn.disabled = false;
        if (textEl) textEl.textContent = originalText;
      });
  }, false);
})();
